module.exports = __webpack_public_path__ + "static/img/ext4.6a924e83.jpg";